export default "__VITE_ASSET__zYdI$QmN__"